module.exports = __webpack_public_path__ + "static/media/alex.a009972b.jpg";